export enum AuthorTypes {
  GET_AUTHOR_DETAILS__ERROR = 'GET_AUTHOR_DETAILS__ERROR',
  GET_AUTHOR_DETAILS__REQUEST = 'GET_AUTHOR_DETAILS__REQUEST',
  GET_AUTHOR_DETAILS__SUCCESS = 'GET_AUTHOR_DETAILS__SUCCESS',
  GET_AUTHOR_DETAILS__CLEAR = 'GET_AUTHOR_DETAILS__CLEAR',
}
